import { Controller } from "@hotwired/stimulus";

// Floating toast notifications with slide-in and fade-out animations
export default class extends Controller {
  static values = { dismissAfter: { type: Number, default: 4000 } };

  connect() {
    if (this.dismissAfterValue > 0) {
      this._timeout = setTimeout(() => this.dismiss(), this.dismissAfterValue);
    }
  }

  disconnect() {
    this._clearTimeout();
  }

  dismiss() {
    this._clearTimeout();
    this._animateOut("fade-out").then(() => this.element.remove());
  }

  // Private

  _animateOut(animation) {
    return new Promise((resolve) => {
      this.element.classList.add(animation);
      this.element.addEventListener(
        "animationend",
        (event) => {
          event.stopPropagation();
          this.element.classList.remove(animation);
          resolve();
        },
        { once: true },
      );
    });
  }

  _clearTimeout() {
    if (this._timeout) {
      clearTimeout(this._timeout);
      this._timeout = null;
    }
  }
}
